import React from 'react';

import { PeaceIcon } from 'components/Icon';

const FreeShippingInidicatorPeaceIcon = () => (
  <div className="FreeShippingIndicator__icon">
    <PeaceIcon />

    <style jsx>
      {`
        .FreeShippingIndicator__icon {
          display: inline-block;
          vertical-align: middle;
          margin-left: 10px;
        }
      `}
    </style>
  </div>
);

export default FreeShippingInidicatorPeaceIcon;
